import AdminRouter from "@/@admin/router";
import { $api, Invitation, RouterUtilClass } from "@/shared";
import { ApiResourceResult } from "@/shared/vuex";
import { StoreOptions } from "vuex";

export interface InvitationsVuexState extends ApiResourceResult<Invitation> {
  invitations?: Invitation[];
  loading: boolean;
}

export const InvitationsVuex: StoreOptions<InvitationsVuexState> = {
  ...{ namespaced: true },
  state: {
    invitations: undefined,
    loading: false,
  },
  mutations: {},
  actions: {
    /**
     * Fetches Invitations
     * @param context
     */
    fetch(context) {
      context.state.loading = true;
      $api.admin
        .get<ApiResourceResult<Invitation>>(
          `/v1/invitations?${RouterUtilClass.extractQuery(AdminRouter)}`
        )
        .then((resp) => {
          context.state.count = resp.data.count;
          context.state.next = resp.data.next;
          context.state.skipped = resp.data.skipped;
          context.state.invitations = resp.data.resources;
          //   Vue.set
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
  },
  modules: {},
  //
  getters: {},
};
